const naturalScienceColors = {
  NATURALS_50: '#FEF3E0',
  NATURALS_100: '#FCDFB2',
  NATURALS_200: '#F9CA80',
  NATURALS_600: '#F18803',
}

export default naturalScienceColors
